/* eslint-disable react/no-array-index-key */
import React, { useContext } from 'react';

import { FiMenu } from 'react-icons/fi';

import { AuthContext } from '~/contexts/authentication';
import { routesConfig } from './routesConfig';
import * as St from './style';
import MenuItem from './subMenu';

const Sidebar: React.FC = () => {
  const { sidebarOpen, handleSideBar } = useContext(AuthContext);

  console.log(sidebarOpen);

  return (
    <St.Sidebar isOpen={sidebarOpen}>
      <St.Menu isOpen={sidebarOpen}>
        <FiMenu onClick={handleSideBar} />
      </St.Menu>

      <St.Navbar>
        {routesConfig.map((route, index) => {
          return <MenuItem fullWidth={sidebarOpen} item={route} key={index} />;
        })}
      </St.Navbar>
    </St.Sidebar>
  );
};

export default Sidebar;
